import _extends from "@babel/runtime-corejs2/helpers/extends";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["as", "icon", "children", "theme", "size", "small", "disabled", "className"];
import * as React from 'react';
import clsx from 'clsx';
import { Interactive } from '../Base';
import Svg from '../Svg';
var styles = {
  "root": "Pill-root_3TDMD",
  "active": "Pill-active_158Df",
  "icon": "Pill-icon_1WHUe",
  "default": "Pill-default_22iwf",
  "small": "Pill-small_-N31f",
  "plain": "Pill-plain_2du3x",
  "disabled": "Pill-disabled_3_CqL"
};
var defaultTheme = {
  bordered: true,
  color: 'anthracite',
  borderColor: 'anthracite',
  backgroundColor: 'transparent'
};
function Pill(_ref) {
  var _clsx;
  var as = _ref.as,
    icon = _ref.icon,
    children = _ref.children,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? defaultTheme : _ref$theme,
    size = _ref.size,
    small = _ref.small,
    disabled = _ref.disabled,
    className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var isBordered = ('bordered' in theme);
  var rootClasses = clsx(styles.root, (_clsx = {}, _defineProperty(_clsx, styles.plain, !isBordered), _defineProperty(_clsx, styles.default, !small), _defineProperty(_clsx, styles.small, small), _defineProperty(_clsx, styles.disabled, disabled), _clsx), className);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Interactive, _extends({
      tagName: as,
      flexInline: true,
      flexAlignItemsCenter: true,
      gap: "spacing-2x",
      size: small ? 'small' : 'base',
      weight: "regular",
      disabled: disabled,
      className: rootClasses
    }, theme, extraProps), icon && Svg.has(icon) && /*#__PURE__*/React.createElement(Svg, {
      name: icon,
      className: styles.icon
    }), children)
  );
}
export default Pill;